import { Documentation } from './Documentation';

export default Documentation;



// WEBPACK FOOTER //
// ./src/scenes/LetterData/LetterDataDetail/components/Documentation/index.tsx